module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.compIsVisible) ? _c('button', {
    staticClass: "edit_upright",
    on: {
      "click": _vm.emitClick
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/edit.svg"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12d6ca85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/EditUprightBtn.vue
// module id = 621
// module chunks = 0